// Module
var code = "<sb-app-structure-and-deliverable-importer style=\"height:100%;width:100%\" id=\"structureAndDeliverableImporter\"></sb-app-structure-and-deliverable-importer> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/import/states/excel/excel.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;